import { Box, Typography } from '@mui/material';

import { MedicalProvider } from '@/services/types/treatment-types';

import { hasPopulatedFields } from '../../../../utils/noteUtils';
import ReadOnlyNoteField from './ReadOnlyNoteField';
import ReadOnlyNoteSection from './ReadOnlyNoteSection';

interface ReadOnlyMedicalNoteSectionProps {
  notes: MedicalProvider[];
}

const ReadOnlyMedicalNoteSection = ({
  notes,
}: ReadOnlyMedicalNoteSectionProps) => {
  if (!notes?.length || !notes.some(hasPopulatedFields)) return null;

  return (
    <ReadOnlyNoteSection title="Medical Information">
      {notes.map((note, index) => (
        <Box
          key={note.id}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            mb: index < notes.length - 1 ? 4 : 0,
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontWeight: 700,
              fontSize: '14px',
              lineHeight: '20px',
              letterSpacing: '0%',
            }}
          >
            {note.name}
          </Typography>
          <ReadOnlyNoteField label="TREATMENT" value={note.treatment} />
          <ReadOnlyNoteField
            label="DATES OF SERVICE"
            value={note.dates_of_service}
          />
          <ReadOnlyNoteField
            label="TREATMENT STATUS"
            value={note.treatment_status}
          />
        </Box>
      ))}
    </ReadOnlyNoteSection>
  );
};

export default ReadOnlyMedicalNoteSection;
